import './../styles/project.css';
import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from "react-router-dom";

const Project = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { name } = useParams(); 
  
  useEffect(() => {
    fetch('https://inkochetkov.github.io/data/projects.json') 
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });
  }, []);
  
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const project = data.find(obj => {
    return obj.name === name;
  });

  if (!project) return <div>Project not found</div>; // Additional check

  return (
    <div className="app">
      <div className="main">
        <ul className="grids">
          <li className="grids_item"></li> 
          <li className="grids_item">
            <div className="grid">
              <div className="grid_content">
                <h2 className="grid_title">{project.name}</h2>
                <br/>
                <p className="grid_text">{project.title}</p>  
                <p className="grid_text">Stack: {project.stack}</p>           
                <p className="grid_text">Description: {project.description}</p>                
                <p className="grid_title">Year: {project.year}</p>
                <br/>
                {project.link && (
                  <a href={project.link} style={{ textDecoration: 'none' }}>                             
                    <button className="btn grid_btn">Link</button>                      
                  </a> 
                )}
                <br/>
                <NavLink to={`/projects/`} style={{ textDecoration: 'none' }}>                             
                  <button className="btn grid_btn">Back</button>                      
                </NavLink>   
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Project;